import { Country, State } from 'country-state-city';
var country = Country.getAllCountries()
var state = State.getStatesOfCountry('US')
export {
    country,
    State,
    state
}